import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["authUrl", "text", "isLink", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Button, Link } from '@mui/material';
import { updateSource } from './update-source';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SocialAuthButton = function SocialAuthButton(_ref) {
  var authUrl = _ref.authUrl,
      text = _ref.text,
      isLink = _ref.isLink,
      sx = _ref.sx,
      buttonProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("form", {
    method: "post",
    action: updateSource(authUrl),
    style: isLink ? {
      display: 'inline',
      padding: 0,
      color: 'black'
    } : {},
    "data-component": "SocialAuthButton",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx("input", {
      name: "_method",
      value: "post",
      type: "hidden",
      "data-component": "SocialAuthButton",
      "data-source-file": "index.tsx"
    }), isLink ? /*#__PURE__*/_jsx(Link, {
      component: "button",
      type: "submit",
      variant: "buttonSmall",
      sx: mergeSxProps({
        ml: 2,
        textDecoration: 'none',
        lineHeight: '120%',
        color: function color(theme) {
          return theme.palette.primary.main;
        },
        '&:hover': {
          textDecoration: 'underline'
        }
      }, sx),
      children: text
    }) : /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      variant: "contained",
      type: "submit"
    }, buttonProps), {}, {
      children: text
    }))]
  });
};